module.exports = __webpack_public_path__ + "img/login-intro.00527dd6.svg";